import PropTypes from 'prop-types'
import {useCallback, useEffect, useRef, useState} from 'react'
import {
  TruncatedTextContainer,
  TruncatedTextPopover,
  TruncatedTextPopoverContent
} from './TruncatedTextWithPopoverStyle'

const TruncatedTextWithPopover = ({children, dataTestId}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const textRef = useRef(null)

  const updateOverflowState = useCallback(() => {
    const textElement = textRef.current

    if (!textElement) {
      setIsOverflowing(false)
      return
    }

    setIsOverflowing(textElement.scrollWidth > textElement.clientWidth)
  }, [])

  const handleOpen = (event) => {
    if (!isOverflowing) return
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    updateOverflowState()
  }, [children, updateOverflowState])

  return (
    <>
      {isOverflowing && (
        <TruncatedTextPopover
          id='truncated-text-popover'
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onClose={handleClose}
          disableRestoreFocus
        >
          <TruncatedTextPopoverContent>{children}</TruncatedTextPopoverContent>
        </TruncatedTextPopover>
      )}
      <TruncatedTextContainer
        ref={textRef}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        onFocus={handleOpen}
        onBlur={handleClose}
        tabIndex={0}
        data-testid={dataTestId}
        aria-haspopup={isOverflowing ? 'true' : undefined}
        aria-owns={anchorEl ? 'truncated-text-popover' : undefined}
      >
        {children}
      </TruncatedTextContainer>
    </>
  )
}

TruncatedTextWithPopover.propTypes = {
  children: PropTypes.node.isRequired,
  dataTestId: PropTypes.string
}

TruncatedTextWithPopover.defaultProps = {
  dataTestId: undefined
}

export default TruncatedTextWithPopover
